
import Env from '../base/env.js';
import Channels from '../base/channels.js';
import lozad from 'lozad'
import Launcher from '../view/launcher'
import MainnavTouch from '../ui/MainnavTouch'
import UISwitcher from '../ui/UISwitcher'
import Smoothie from '../fx/Smoothie'

class UI
{
    constructor()
    {
      if(typeof history.scrollRestoration != 'undefined') {
          history.scrollRestoration = 'manual';
      }
      this.launcher = new Launcher()
      this.uiSwitch =  new UISwitcher()
      Env.framework.mainnav = new MainnavTouch()
      this.detectAppHeight()
      this.resetEnv();
      // Smooth
      this.smoothie = new Smoothie()
      this.smoothie.setup()
      this.lazy()
    }

    appHeight()
    {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }

    detectAppHeight()
    {
      this.appHeight()
      Channels.on('window::smartresize',this.appHeight)
    }

    lazy()
    {
      // For Picture Tag
      const picture_observer = lozad('.jsLozad-pic', {
        load: (el)=> {
          const sources = el.querySelectorAll('source')
          for(let source of sources) {
            source.setAttribute('srcset',source.getAttribute('data-srcset'))
          }
          const imgs = el.querySelectorAll('img')
          for(let img of imgs) {
            img.setAttribute('srcset',img.getAttribute('data-srcset'))
            img.setAttribute('src',img.getAttribute('data-src'))
          }
        }
      });
      picture_observer.observe();

      // For classic lozad elements
      const observer = lozad('.lozad'); // lazy loads elements with default selector as '.lozad'
      observer.observe();
    }

    resetEnv()
    {
      Channels.on('statechange::before',function()
      {
        Env.$html.classList.remove('mainnav--isOpened')
        Env.$html.classList.remove('subnav--isOpened')
      })
      Channels.on('statechange::ready',(current,old,container)=>
      {
        Env.isVisiting = true
        // Env.$html.classList.remove('skin--isWhite')
        // Env.$html.classList.remove('skin--isDark')
        // Env.$mainNav.classList.remove('is--active');
        // Env.$html.classList.remove('mainnav--isOpened')
        if(Env.isVisiting === true) {
          if(typeof Env.framework.UI.smoothie != 'undefined') {
            Env.framework.UI.smoothie.setup()
          }
        }
      })
      Channels.on('statechange::finalize',()=>{
        this.lazy()
      })
    }
}

export default UI;
